import { iphoneCricketStore } from '../../link-actions';
import { PromoBestWayToTry, PromoMidSection } from '../promoMidSection';
import { getPromo } from '../../promos';
import AnalysisSection from '../AnalysisSection';
import ReplaySection from '../ReplaySection';
import AutoPauseSection from '../AutoPauseSection';
import CastSection from '../CastSection';
import AutoSaveSection from '../AutoSaveSection';
import BottomCallToAction from '../BottomCallToAction';
import LoopExplainerSection from '../LoopExplainerSection';

export const CricketBowlingBase = (props) => {
    let sportKey = "cricket";
    const promo = getPromo(sportKey);

    return (<div>
          {props.banner}

          <AnalysisSection
                      headline="Real-time bowling analysis"
                      subHeading="Improve quickly with instant feedback after every delivery."
                      analysers={[
                            { src: "./assets/img/cricket/analyze_arm_angle.png", caption: "Arm angle" },
                            { src: "./assets/img/cricket/analyze_joint_track.png", caption: "Joint track" },
                            { src: "./assets/img/cricket/analyze_elbow_angle.png", caption: "Elbow angle" },
                            { src: "./assets/img/cricket/analyze_knee_angle.png", caption: "Knee bend" },
                            { src: "./assets/img/cricket/analyze_arm_leg_alignment.png", caption: "Arm alignment" },
                            { src: "./assets/img/cricket/analyze_stride_length.png", caption: "Stride length" }
                      ]}
                  />

            <ReplaySection headline="Slow-motion instant replays" subHeading="Simply bowl, wait for the delay, and watch the replay. All hands free." image="/assets/img/cricket/replay_compare.png" />
            
            <AutoPauseSection headline="Auto-pause at gather, release, and follow through" subHeading="Pause the replay without touching your phone."
                        imageLeft={{src: "/assets/img/cricket/auto_pause_keyframes.png", alt: "Auto-pause at key frames", caption: "Key frames are shown on the timeline so you can easily move to important moments."}}
                        imageRight={{src: "/assets/img/cricket/auto_pause_options.png", alt: "Configure auto-pause", caption: "Configure pause frame and duration.  The replay will continue once the duration is over."}}
                    />

            <PromoMidSection promo={promo} />

            <CastSection headline="Cast replay to tablet or laptop" subHeading="Optionally connect a second device to watch and analyze on a bigger screen, in your follow through." images={[
                        {src: "./assets/img/cricket/bowling/view_ipad.png", alt: "Watch replay at your feet"}
                    ]} />

            <AutoSaveSection headline="Auto-save every bowl" subHeading="All deliveries are individually saved, so you can re-watch them with a single tap." image="/assets/img/cricket/bowling/cricket_library.png" />
            
            <section className="atf-section-padding" style={{background: 'url(./assets/img/smokebg_white_light_compressed.jpg)', backgroundRepeat: 'no-repeat'}}>
                <div className="container">
                    <div className="row justify-content-center clearfix">
                        <div className="col-lg-8 col-12 align-self-center">
                            <div>
                                <h2 className="heading-size text-center">Configure for any skill level</h2>
                                <p  className="text-center" style={{ fontSize: "18px", lineHeight: "1.7", margin: "5px 0 10px 0"  }}>Set the threshold of a "good or bad" bowl to suit skill level and bowling style.</p>
                            
                            </div>
                        </div>
                        <div className="col-lg-4 col-12 text-center">
                        <img src="./assets/img/cricket/bowling/configure_angle.png" alt="Configure settings"/>
                        </div>
                    </div>
                </div>
            </section>


          <LoopExplainerSection action="Bowl" />

          <section className="atf-section-padding" style={{ paddingTop: "40px", paddingBottom: "0px" }}>
              <div className="container">
                  <div className="row justify-content-center">
                      <div className="col-11 align-self-center text-center" style={{backgroundImage: 'url(assets/img/golf_collage.png)', backgroundSize: 'cover', backgroundPosition: 'center center'}}>
                          <div style={{ margin: '20px 10px 20px 10px', padding: '10px', background:"white"}}>
                              <h2 style={{ display: "inline-block", fontSize: '34px', lineHeight:"1.5", marginBottom: "10px", color:"var(--thm-black)",padding: "5px"}}>Over 1000 users</h2><br />
                              <div style={{ display: "inline-block", fontSize: '16px', marginBottom: "10px", lineHeight: "1.5", padding: "3px"}}>"See why PracticeLoop is the new way to learn to bowl"</div>
                          </div>
                      </div>
                  </div>
              </div>
          </section>

            <PromoBestWayToTry promo={promo} />


        <BottomCallToAction promo={promo} onClick={() => iphoneCricketStore(`${sportKey}_video_bottom_cta`)} />
          
      </div>
    );
}

export default CricketBowlingBase;